import React from 'react';
import { Marker, Popup } from 'react-leaflet';
import useZoomLevel from './useZoomLevel'; 

const MarkersEditing = ({ markers, manholeMarker, icon, removeMarker, type }) => {

  const zoomLevel = useZoomLevel();

  if (zoomLevel <= 15) {
    return null;
  }

  return (
    <>
      {markers.map((marker, index) => (
        <Marker
          key={index}
          position={[marker.lat, marker.lng]}
          icon={icon}
        >    
         {manholeMarker && (         
            <Popup autoClose={false} className="custom-popup">
           
              <div>
                
                <label style={{ color: '#555555', fontSize: '16px' }}>{type}</label>
                <hr className="horizontalLinePopup" />
                <button className="popupButtonDelete" onClick={(e) => { e.stopPropagation(); removeMarker(index); }}>Удалить маркер</button>
              </div>
              
            </Popup> 
             )};       
        </Marker>
      ))}
    </>
 );
}

export default MarkersEditing;